import { CollectionActionType } from '../../../../../../shared/types/collectionActionType';

export const MENU_ITEMS = [
    {
        name: CollectionActionType.EDIT,
        titleKey: 'collections_perseus.actions.edit',
    },
    {
        name: CollectionActionType.DELETE,
        titleKey: 'collections_perseus.actions.delete',
    },
];
